import { paginationHeaders, get } from './index.js'

const URL = process.env.API_URL + 'api/course_interests'

export const getAll = (page = 1, perPage = 10, sortKey = 'id', sort = 'DESC') =>
  get(URL, paginationHeaders({ page, perPage, sort, sortKey })).then(
    ({ data }) => data,
  )
